import { faqData } from '@/data/faqData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function FAQ() {
  return (
    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-100">Frequently Asked Questions</h2>
      <Accordion type="multiple" className="w-full mb-8">
        {faqData.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`} className="border-b border-gray-200 dark:border-gray-700">
            <AccordionTrigger className="text-left font-bold text-lg text-gray-800 dark:text-gray-100 hover:text-primary dark:hover:text-primary-foreground py-4">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-gray-700 dark:text-gray-200 leading-relaxed pb-4">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}